export default "__VITE_ASSET__BE9OkJ5a__"